import ManageType from '@shared/manage/manage-enum';
import ManageEnum from '@shared/manage/manage-enum';

class ManageFactory {
    constructor(manageType) {
        this.optionsValues = {}         // options for manage enumerator
        this.manageUserFormShow = {     // manageUserSHow for hidde selects on views per manage
            admin: false,
            property: false,
            subproperty: false,
            program: false,
            subprogram: false
        }

        switch (manageType) {
            case ManageType.values.ADMIN:
                this.optionsValues = {
                    admin: ManageEnum.values.ADMIN,
                    property: ManageEnum.values.PROPERTY,
                    subproperty: ManageEnum.values.SUBPROPERTY,
                    // program: ManageEnum.values.PROGRAM,
                    // subprogram: ManageEnum.values.SUBPROGRAM,
                }
                this.manageUserFormShow.admin = true;
                break;

            case ManageType.values.PROPERTY:
                this.optionsValues = {
                    property: ManageEnum.values.PROPERTY,
                    subproperty: ManageEnum.values.SUBPROPERTY,
                    // program: ManageEnum.values.PROGRAM,
                    // subprogram: ManageEnum.values.SUBPROGRAM,
                }
                this.manageUserFormShow.property = true;
                break;

            case ManageType.values.SUBPROPERTY:
                this.optionsValues = {
                    subproperty: ManageEnum.values.SUBPROPERTY,
                    // program: ManageEnum.values.PROGRAM,
                    // subprogram: ManageEnum.values.SUBPROGRAM,
                }
                this.manageUserFormShow.property = true;
                this.manageUserFormShow.subproperty = true;
                break;

            case ManageType.values.PROGRAM:
                this.optionsValues = {
                    program: ManageEnum.values.PROGRAM,
                    subprogram: ManageEnum.values.SUBPROGRAM,
                }
                this.manageUserFormShow.property = true;
                this.manageUserFormShow.subproperty = true;
                this.manageUserFormShow.program = true;
                break;

            case ManageType.values.SUBPROGRAM:
                this.optionsValues = {
                    subprogram: ManageEnum.values.SUBPROGRAM,
                }
                this.manageUserFormShow.property = true;
                this.manageUserFormShow.subproperty = true;
                this.manageUserFormShow.program = true;
                this.manageUserFormShow.subprogram = true;
                break;
            default:
                break;
            //  throw (`unknow manageType ${manageType} unknow ManageFactory`);
        }

    }
}

export default ManageFactory;